import {get, post, put} from "../core/api";
import {MenuStructureResponse} from "./models/AdviceLibrary";
import {ClientMeetingDocumentsResponse, LinkUnlinkPWClientRequest} from "./models/ClientDocuments";
import {ComparePlan} from "../Plans/CompareScenarios/ComparePlan";

const getAdviceLibraryDocument = async (menuTitle: string, documentLabel: string, subMenuLabel: string): Promise<Blob> => {
    const response = await get(`/advisory/adviceLibrary/getDocumentFromCache`, {
        queryParams: {
            menuTitle,
            documentLabel,
            subMenuLabel
        }
    });
    return response.blob();
}

const getMenuStructure = async (isRefresh: boolean): Promise<MenuStructureResponse> => {
    const response = await get(`/advisory/adviceLibrary/menu`, {
        queryParams: {
            isRefresh
        }
    });
    return response.json();
}

const getClientMeetingDocuments = async (profileId: string, clientName: string, ownerId: string, resourceCode: string, refreshServiceTeam: string): Promise<ClientMeetingDocumentsResponse> => {
    const response = await get(`/advisory/client/documents`, {
        queryParams: {
            profileId,
            clientName: clientName.trim(),
            ownerId,
            resourceCode,
            refreshServiceTeam
        }
    });
    return response.json();
}

const getMyDocuments = async (lanId: string, profileId: string): Promise<ClientMeetingDocumentsResponse> => {
    const response = await get(`/advisory/my/documents/${profileId}`, {
        queryParams: {
            lanId
        }
    });
    return response.json();
}

const getClientMeetingDocumentBlob = async (itemId: string, documentType: string, profileId: string, extension: string): Promise<Blob> => {
    const response = await get(`/advisory/client/documents/getDocumentBlob/${profileId}`, {
        queryParams: {
            itemId,
            documentType,
            extension
        }
    });
    return response.blob();
}

const linkUnlinkPWClient = async (profileId: string, reqBody: LinkUnlinkPWClientRequest): Promise<Response> => {
    return post(`/advisory/client/documents/linkUnlinkClient/${profileId}`, reqBody);
}


export const postComparePlan = (profileId: string, comparePlanRequest: { comparePlan1SelectedId: string | undefined; comparePlan2SelectedId: string | null }): Promise<Response> => {
    return post(`/advisory/client/comparePlans/${profileId}`, comparePlanRequest);
}
export const putComparePlan = (profileId: string, comparePlanRequest: { comparePlan1SelectedId: string | undefined; comparePlan2SelectedId: string | null }): Promise<Response> => {
    return put(`/advisory/client/comparePlans/${profileId}`, comparePlanRequest);
}
export const getComparePlan = async (profileId: string): Promise<ComparePlan> => {
    const response = await get(`/advisory/client/comparePlans/${profileId}`)
    return response.json();
}

export const resourcesApiClient = {
    getAdviceLibraryDocument,
    getMenuStructure,
    getClientMeetingDocuments,
    getMyDocuments,
    getClientMeetingDocumentBlob,
    linkUnlinkPWClient,
    postComparePlan,
    putComparePlan,
    getComparePlan
};